import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { newDepartamentoSchema } from '@/shared';
import {
  SingleFormBoxScene,
  CustomAutocomplete,
  SampleCheckbox,
  CustomTextField
} from '@/shared/components/ui';
import { useCreateDepartamento, useUpdateDepartamento, useFetchAreas, usefetchEmpresas } from '@/shared/actions/erp';

import { Departamento, Area, Empresa } from '@/shared/interfaces';

const returnUrlDep = '/parametrizacion/departamentos';

export interface SaveDepartamentoInterface {
  titlePage: string;
  editDepartamento?: Departamento;
}
type SaveFormData = {
  nombre: string;
  area: string;
  empresa: string
  estado: boolean;
};
const SaveDepartamentoPage: React.FC<SaveDepartamentoInterface> = ({ titlePage, editDepartamento }) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);


  ///* mutations
  const createDepartamentoMutation = useCreateDepartamento({ navigate, returnUrl: returnUrlDep });
  const updateDepartamentoMutation = useUpdateDepartamento({ navigate, returnUrl: returnUrlDep });
  ///* fetch data
  const { data: AreasPaging, isLoading: isLoadingAreas } = useFetchAreas({
    page_size: 600,
  });
  const { data: EmpresaPaging, isLoading: isLoadingEmpresa } = usefetchEmpresas({
    page_size: 600,
  });

  ///*fetch
  const onChangeDepartament = (value: string) => {
    form.setValue('area', value);
  }
  const onChangeEmpresa = (value: string) => {
    form.setValue('empresa', value);
  }
  ///* effects



  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newDepartamentoSchema),
    defaultValues: { estado: false }, // Set default value for estado
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editDepartamento?.id_departamento) {
      return updateDepartamentoMutation.mutate({
        id: editDepartamento.id_departamento,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createDepartamentoMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editDepartamento) {
      setShrink(true);
      reset({
        ...editDepartamento,
      } as any);
    }
  }, [editDepartamento]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlDep);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        name="nombre"
        label="Nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />

      <CustomAutocomplete<Area>
        label="Area"
        name="area"
        //// options
        options={AreasPaging?.data.data || []}
        // label & search by name
        valueKey="nombre"
        actualValueKey='codigo'
        //
        defaultValue={form.getValues().area || ''}
        optionLabelForEdit={form.getValues().area || ''}
        isLoadingData={isLoadingAreas}
        //// validation
        control={form.control}
        error={errors.area}
        helperText={errors.area?.message}
        onChangeValue={onChangeDepartament}
      />
      <CustomAutocomplete<Empresa>
        label="empresa"
        name="empresa"
        //// options
        options={EmpresaPaging?.data.data || []}
        // label & search by name
        valueKey="razon_social"
        actualValueKey='codigo'
        //
        defaultValue={form.getValues().area || ''}
        optionLabelForEdit={form.getValues().area || ''}
        isLoadingData={isLoadingEmpresa}
        //// validation
        control={form.control}
        error={errors.area}
        helperText={errors.area?.message}
        onChangeValue={onChangeEmpresa}
      />
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado || false}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveDepartamentoPage;
